export const userDeviceDetect = () => {
  const { userAgent } = navigator;
  const isAndroid = Boolean(
    userAgent.match(/Android|BlackBerry|Opera Mini|IEMobile|WPDesktop/i)
  );
  const isIos = Boolean(userAgent.match(/iPhone|iPad|iPod/i));

  return { isAndroid, isIos };
};
